'use strict'

module.exports = clear

/**
 * destroys db
 */
function clear (state) {
  return state.db.destroy()
    .then(function () {
      state.emitter.emit('clear')
    })
}



//////////////////
// WEBPACK FOOTER
// ./~/pouchdb-hoodie-api/lib/clear.js
// module id = 744
// module chunks = 7